/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An hour mirrors the section length of many standardized tests, so practicing with the same time limit trains pacing, not just content knowledge. Timing practice sessions the same way as the real exam is a commonly recommended way to build accurate pacing habits before test day.`)
};

const es_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una hora refleja la duración de sección de muchos exámenes estandarizados, así que practicar con el mismo límite de tiempo entrena el ritmo, no solo el conocimiento del contenido. Cronometrar las sesiones de práctica igual que el examen real es una forma comúnmente recomendada de desarrollar buenos hábitos de ritmo antes del día del examen.`)
};

const de_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Stunde spiegelt die Abschnittslänge vieler standardisierter Tests wider, sodass das Üben mit demselben Zeitlimit das Tempo trainiert, nicht nur das Fachwissen. Übungssessions genauso zu timen wie die echte Prüfung, ist eine häufig empfohlene Methode, um vor dem Testtag ein präzises Zeitgefühl aufzubauen.`)
};

const nl_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een uur weerspiegelt de lengte van onderdelen van veel gestandaardiseerde tests, dus oefenen met dezelfde tijdslimiet traint je tempo, niet alleen kennis van de stof. Oefensessies op dezelfde manier timen als het echte examen is een veelaanbevolen manier om een nauwkeurig tempo op te bouwen vóór de testdag.`)
};

const fr_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une heure reproduit la durée des sections de nombreux tests standardisés, donc s’entraîner avec la même limite de temps travaille la gestion du rythme, pas seulement la connaissance du contenu. Chronométrer les sessions d’entraînement de la même manière que l’examen réel est une méthode couramment recommandée pour développer de bonnes habitudes de rythme avant le jour J.`)
};

const it_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'ora rispecchia la durata delle sezioni di molti test standardizzati, quindi esercitarsi con lo stesso limite di tempo allena la gestione del ritmo, non solo la conoscenza dei contenuti. Cronometrare le sessioni di pratica allo stesso modo dell'esame reale è un metodo comunemente consigliato per costruire abitudini di ritmo accurate prima del giorno del test.`)
};

const pt_br2_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma hora reflete a duração de seção de muitos testes padronizados, então praticar com o mesmo limite de tempo treina o ritmo, não apenas o conhecimento do conteúdo. Cronometrar sessões de prática da mesma forma que a prova real é uma maneira comumente recomendada de desenvolver hábitos precisos de ritmo antes do dia do exame.`)
};

const pt_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma hora reflete a duração de secção de muitos testes estandardizados, pelo que praticar com o mesmo limite de tempo treina o ritmo, não apenas o conhecimento do conteúdo. Cronometrar as sessões de prática da mesma forma que o exame real é uma forma comummente recomendada de construir hábitos de ritmo precisos antes do dia do teste.`)
};

const ja_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1時間は多くの標準テストのセクションの長さを反映しているため、同じ制限時間で練習することで、内容の知識だけでなくペース配分も鍛えられます。実際の試験と同じ方法で時間を計って練習することは、本番前に正確なペース配分の感覚を身につけるためによく推奨される方法です。`)
};

const zh_timer_u1h_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一小时与许多标准化考试的分段时长一致，因此按相同的时间限制练习不仅能巩固知识，还能训练答题节奏。按照真实考试的方式为练习计时，是考前建立准确节奏感的常见推荐方法。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_faq4_a", locale)
	if (locale === "en") return en_timer_u1h_faq4_a(inputs)
	if (locale === "es") return es_timer_u1h_faq4_a(inputs)
	if (locale === "de") return de_timer_u1h_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u1h_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u1h_faq4_a(inputs)
	if (locale === "it") return it_timer_u1h_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u1h_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u1h_faq4_a(inputs)
	return zh_timer_u1h_faq4_a(inputs)
};